import { UNIFIED_DROPDOWN_MAX_HEIGHT_REM } from '@themes/overrides/constants';

export default function Menu() {
  return {
    MuiMenu: {
      defaultProps: {
        disableScrollLock: true,
      },
      styleOverrides: {
        paper: {
          maxHeight: UNIFIED_DROPDOWN_MAX_HEIGHT_REM,
        },
      },
    },
  };
}
